export default {
  largest: "75em", // 1200px
  large: "62.5em", // 1000px
  medium: "50em", // 800px;
  mediumLite: "48rem", // 768px;
  small: "36em", // 576px;
  smaller: "29em", // 464px;
  smallest: "25em" // 400px;
};
